let toggle = null;
let navigation = null;

function toggleHandler() {
   if (toggle && navigation) {
      toggle.classList.toggle("is-active");
      navigation.classList.toggle("is-visible");
   }
}

window.addEventListener("DOMContentLoaded", () => {
   toggle = document.querySelector(".navigation__toggle");
   navigation = document.querySelector(".navigation");

   if (toggle) {
      toggle.addEventListener("click", toggleHandler);
   }
});
